module.exports = __webpack_public_path__ + "static/mc_app_steps_enviar_recibir-8022dc15deac5db25862a5f90249f558.gif";